import { OrganisationUser, Role, PaginationMeta, UserFilter } from '../types';
import Organisation from '@/models/Organisation';

export interface IUserState {
  organisationUsers: OrganisationUser[];
  organisationClients: Organisation[];
  roles: Role[];
  userPaginationMeta: PaginationMeta;
  clientPaginationMeta: PaginationMeta;
  appliedFilter: UserFilter;
}

export const UserState: IUserState = {
  organisationUsers: [],
  organisationClients: [],
  roles: [],
  userPaginationMeta: {} as PaginationMeta,
  clientPaginationMeta: {} as PaginationMeta,
  appliedFilter: {
    searchKeyword: ''
  }
};
